<h3 mat-dialog-title>
  Fyll i information för vidarebefordran
</h3>

<mat-dialog-content>
  <form [formGroup]="formGroup">
    <mat-form-field class="example-form-field" appearance="outline">
      <mat-label>PO-nummer</mat-label>
      <input autofocus matInput type="text" formControlName="poNumber" />
    </mat-form-field>

    <mat-form-field class="example-form-field" appearance="outline">
      <mat-label>Kreditnummer</mat-label>
      <input matInput type="text" formControlName="creditNumber" />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="buttons-container">
    <button mat-stroked-button (click)="onCancel()">Avbryt</button>
    <button mat-flat-button (click)="submitForm()">Spara</button>
  </div>
</mat-dialog-actions>
